import { SET_LAYOUT_VIEW } from '../constants/action-types';

// VIEW (GRID, LIST)

//  SET_LAYOUT_VIEW    
export const setLayoutView = (view = '') => ({
    type: SET_LAYOUT_VIEW,
    view
});